import React from "react";
import { CircleCheckBig, X } from 'lucide-react';
const Pricing = () => {
    return (
        <div className="py-10 bg-white">
            <div className="flex justify-center ">
                <h2 className="text-3xl m-auto text-center mb-10 font-bold inline-block border-b-2 border-brandRed p-2">
                    Pricing
                </h2>
            </div>
            <div className="flex flex-col md:flex-row justify-center items-center gap-6 px-4 m-auto mt-4 p-3">
                {/* Pricing Plans Data */}
                {[
                    {
                        name: "SILVER PLAN",
                        description: "Perfect for side or hobby projects",
                        // price: "5999",
                        features: [
                            "Process Unlimited Payments",
                            "Activate Three Business Services",
                            "Analyze and Predict Financial Trends"
                        ],
                        unavailable: [2],
                        tag: null
                    },
                    {
                        name: "GOLD PLAN",
                        description: "Perfect for Mid level Agents",
                        // price: "6999",
                        features: [
                            "Process Unlimited Payments",
                            "Activate Three Business Services",
                            "Analyze and Predict Financial Trends"
                        ],
                        unavailable: [],
                        tag: "Popular"
                    },
                    {
                        name: "BRONZE PLAN",
                        description: "Perfect for Small Agency",
                        // price: "4999",
                        features: [
                            "Process Unlimited Payments",
                            "Activate Three Business Services",
                            "Analyze and Predict Financial Trends"
                        ],
                        unavailable: [],
                        tag: null
                    }
                ].map((plan, index) => (
                    <div key={index} className="w-full max-w-sm relative pricing-card p-6">
                        {plan.tag && (
                            <div className="popular-tag">{plan.tag}</div>
                        )}
                        <h3 className={`text-center text-lg font-bold ${plan.name === 'GOLD PLAN' ? 'text-brandRed' : ''}`}>{plan.name}</h3>
                        <p className="text-center text-sm text-gray-600 mb-4">{plan.description}</p>
                        <div className="text-center text-3xl font-bold">{plan.price}</div>
                        <p className="text-center text-sm text-gray-500 mb-4">Service fee / Payment</p>
                        <ul className="space-y-2 mb-6">
                            {plan.features.map((feature, i) => (
                                <li
                                    key={i}
                                    className={`flex items-center gap-2 ${plan.unavailable.includes(i) ? 'text-gray-400 line-through' : ''}`}
                                >
                                    <span>{plan.unavailable.includes(i) ? <X size={20} color="gray" /> : <CircleCheckBig size={20} color="red" />}</span> {feature}
                                </li>
                            ))}
                        </ul>
                        <button className="get-started-btn">Get started</button>
                    </div>

                ))}
            </div>
        </div>
    );
};

export default Pricing;
